// extracted by mini-css-extract-plugin
export default {"select":"styles_select__0YuX+","icon":"styles_icon__8lGd4"};